export enum ApprovalTypeEnum {
  PROSPECTUS = 'PROSPECTUS',
  REGN = 'REGN',
  URGN = 'URGN',
  SUPPLEMENT = 'SUPPLEMENT',
}
